import { LoggerService } from '../../core/logger/logger.service';

// Queryable identifier for OrionIQ chat free-text feedback logs. Thumbs up/down stay in PostHog; only the
// comment text is shipped to the platform as a log (ORIONIQ-1096) — query by this `logIdentifier`.
export const ORION_CHAT_FEEDBACK_LOG_IDENTIFIER = 'AI/ORION_CHAT_FEEDBACK';

interface ILogOrionChatFeedbackParams {
  // Which chat surface produced the feedback, so queries can split Open 360 from the OrionIQ app. PostHog events
  // use the `app` property for the same split; this log predates it and keeps its own field.
  product: 'open360' | 'orioniq';
  score: 'up' | 'down';
  comment: string;
  messageIndex: number;
  sessionId?: string;
  runId?: string;
}

// Ship a user's free-text chat feedback to the platform as a queryable INFO log. Shared by both OrionIQ chat
// consumers so the log shape + identifier stay identical.
export const logOrionChatFeedback = ({
  product,
  score,
  comment,
  messageIndex,
  sessionId,
  runId,
}: ILogOrionChatFeedbackParams): void => {
  LoggerService.logInfo({
    message: 'OrionIQ chat feedback',
    extra: {
      logIdentifier: ORION_CHAT_FEEDBACK_LOG_IDENTIFIER,
      product,
      score,
      comment,
      messageIndex,
      sessionId,
      runId,
    },
  });
};
